<template>
  <b-modal
    id="modaldemand"
    ref="modaldemand"
    title="Editar Veículo"
    size="xl"
    ok-title="Registrar"
    cancel-title="Cancelar"
    @hidden="leave"
    @ok="handleOk"
  >
  <form ref="form" @submit.stop.prevent="handleSubmit">
    <div class="row">
        <b-alert show variant="info">
          Todos os campos são obrigatórios
        </b-alert>
    </div>
    <div class="row">
      <div class="col-4">
        <label for="input-modelo">Modelo:</label>
        <b-form-input
          id="input-modelo"
          v-model="myDemand.modelo"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-up">UP:</label>
        <b-form-input
          id="input-up"
          v-model="myDemand.up"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-classe">Subsegmento:</label>
        <b-form-input
          id="input-classe"
          v-model="myDemand.classe"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <label for="input-anomodelo">Ano Modelo:</label>
        <b-form-input
          id="input-anomodelo"
          v-model="myDemand.anomodelo"
          required
        />
      </div>
      <div class="col-6">
        <label for="input-anofabricacao">Ano Fabricação:</label>
        <b-form-input
          id="input-anofabricacao"
          v-model="myDemand.anofabricacao"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <label for="input-codigocor">Código Cor:</label>
        <b-form-input
          id="input-codigocor"
          v-model="myDemand.codigo_cor"
          required
        />
      </div>
      <div class="col-6">
        <label for="input-cor">Cor:</label>
        <b-form-input
          id="input-cor"
          v-model="myDemand.cor"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-4">
        <label for="input-concessionario">Concessionário:</label>
        <b-form-input
          id="input-concessionario"
          v-model="myDemand.concessionario"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-contato">Contato:</label>
        <b-form-input
          id="input-contato"
          v-model="myDemand.contato"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-telefone">Telefone:</label>
        <b-form-input
          id="input-telefone"
          v-model="myDemand.telefone"
          required
        />
      </div>
    </div>
  </form>
  </b-modal>
</template>

<script>
import EventBus from '../../../eventBus';

export default {
  props: ['demand'],

  data: () => ({
    myDemand: {},
  }),

  beforeUpdate() {
    this.myDemand = this.demand;
  },

  methods: {
    leave() {
      this.myDemand = this.demand;
    },
    save() {
      EventBus.$emit('saveDemandInfo', this.myDemand);
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      this.save();
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modaldemand');
      });
    },
  },
};
</script>

<style scoped>
</style>
